const traffic = {
  't-global-config': 'Глобальная конфигурация',
  't-save-config': 'Сохранить конфиг',
  't-time-window': 'Временное окно',
  't-time-window-seconds': 'Временное окно (с)',
  't-max-download-count': 'Макс. загрузок',
  't-max-retry-count': 'Макс. повторов',
  't-global-config-hint': 'Партнёры без индивидуальной конфигурации будут использовать это глобальное значение по умолчанию. Применяется только к устройствам mpush.',
  't-circuit-breaker-strategy': 'Стратегия автоматического выключателя',
  't-circuit-breaker-enabled': 'Этот Partner будет применять независимую стратегию автоматического выключателя',
  't-circuit-breaker-disabled': 'Использовать глобальную конфигурацию при отключении',
  't-config-params': 'Параметры конфигурации',
  't-time-window-label': 'Временное окно',
  't-max-download-label': 'Макс. загрузок',
  't-max-retry-label': 'Макс. повторов',
  't-ban-behavior-title': 'Описание поведения блокировки',
  't-ban-behavior-desc': 'Повторы исчерпаны → Устройство входит в заблокированное состояние → Все запросы загрузки в текущем окне возвращают {0}, устройство прекращает загрузку',
  't-download-settings': 'Настройки загрузки',
  't-traffic-mgmt': 'Управление трафиком',
  "t-error-download-settings": "Ограничитель скорости",
  't-add-config': 'Добавить конфигурацию',
  't-edit-config': 'Редактировать конфигурацию',
  't-status-enabled': 'Включено',
  't-status-disabled': 'Отключено',
  't-select-partner': 'Пожалуйста, выберите Partner',
  't-select-partner-required': 'Пожалуйста, выберите Partner',
  't-fill-time-window': 'Пожалуйста, заполните временное окно',
  't-save-success': 'Успешно сохранено',
  't-save-failed': 'Ошибка сохранения',
  't-update-success': 'Успешно обновлено',
  't-update-failed': 'Ошибка обновления',
  't-add-success': 'Успешно добавлено',
  't-add-failed': 'Ошибка добавления',
  't-load-failed': 'Ошибка загрузки данных',
  't-second': 'с',
  't-times': 'раз',
  't-fill-max-download': 'Пожалуйста, укажите максимальное количество загрузок',
  't-fill-allowed-retry': 'Пожалуйста, укажите допустимое количество повторов',
  't-time-window-range-error': 'Временное окно должно быть от 1 до 7200',
  't-max-download-range-error': 'Максимальное количество загрузок должно быть от 5 до 200',
  't-allowed-retry-range-error': 'Допустимое количество повторов должно быть от 1 до 20',
  't-traffic-overview': 'Обзор трафика',
  't-monthly-total-traffic': 'Общий трафик за месяц',
  't-compared-last-month': 'к прошлому месяцу',
  't-partner-count': 'Количество Partner',
  't-this-month-new': 'новых в этом месяце',
  't-over-limit-partner': 'Partner сверх лимита',
  't-need-attention': 'Требует внимания',
  't-all-partner': 'Все Partner',
  't-all-usage-rate': 'Все уровни использования',
  't-current-month-used-traffic': 'Использованный трафик за месяц',
  't-traffic-limit': 'Лимит трафика',
  't-usage-rate': 'Уровень использования',
  't-this-month-download-count': 'Загрузки за месяц',
  't-normal': 'Норма',
  't-about-to-exceed': 'Почти лимит',
  't-exceeded': 'Превышено',
  't-unlimited': 'Безлимит',
  't-unlimited-traffic': 'Безлимитный трафик',
  't-view-traffic-detail': 'Просмотреть детали трафика',
  't-download-records': 'Загрузки за месяц',
  't-file-name': 'Имя файла',
  't-file-size': 'Размер файла',
  't-usage-history': 'История использования данных',
  't-data-usage-trend': 'Тренд использования данных',
  't-last-30-days-data-usage-trend': 'Тренд использования данных за последние 30 дней',
  't-used-traffic': 'Использованный трафик',
  't-last-12-months-traffic-trend': 'Тренд трафика за последние 12 месяцев',
  't-month': 'Месяц',
  't-all-months': 'Все месяцы',
  't-download-count': 'Количество загрузок',
  't-quota-configuration': 'Лимиты трафика',
  't-global-default-config': 'Глобальная конфигурация по умолчанию',
  't-global-default-traffic-limit': 'Глобальный лимит трафика по умолчанию',
  't-current-config': 'Текущая конфигурация',
  't-quota-global-config-hint': 'Partner без индивидуальной настройки лимита трафика будут использовать это значение по умолчанию. Установите 0 для безлимитного трафика.',
  't-partner-traffic-limit-config': 'Настройка лимита трафика Partner',
  't-config-type': 'Тип конфигурации',
  't-use-global': 'Использовать глобально',
  't-custom': 'Пользовательский',
}

export default traffic
